import { SettingsCommunitySortTypes, } from "./community";
import { Maybe } from "./util/maybe";
export const defaultLiveLinkTextLabel = "View community options";
const defaultDefaultCommunitySortOrder = "name";
const makeCallsFromOf = (value) => value === "phone" ? "phone" : "browser";
export class UserPreferences {
    constructor() {
        this.displayBestContactPhoneOnDashboard = false;
        this.showAdditionalContactsForReferrals = true;
        this.showContactPhoneNumbersForReferrals = false;
        this.showClientBudget = true;
        this.showClientLocation = true;
        this.showContactEmailAddrsForReferrals = false;
        this.showContactLocationsForReferrals = false;
        this.showCareProvidersForReferrals = true;
        this.showHealthInsuranceForReferrals = true;
        this.showReferralCityOnMainTable = false;
        this.showReferralLastUpdatedDateOnMainTable = false;
        this.clientUpdateNotifications = true;
        this.clientUpdateReferralOwnerNotifications = false;
        this.useBulkCommunityEmail = true;
        this.preferAge = false;
        this.activeTaskSortOrder = "dueDateAscending";
        this.completedTaskSortOrder = "completedDateAscending";
        this.reminderEnabled = false;
        this.reminderEnabledDate = null;
        this.defaultCommunityCompareTemplateId = undefined;
        this.defaultShowCoverPage = false;
        this.liveLinkURLText = defaultLiveLinkTextLabel;
        this.attachCommunityPDFByDefault = true;
        this.useLiveLinkByDefault = true;
        this.defaultCommunitySortOrder = defaultDefaultCommunitySortOrder;
        this.workflowSettings = {};
        this.bccMyself = true;
        this.taskDuration = 30;
        this.preferredClientAssignmentFilter = "myself";
        this.taskAssignmentNotifications = true;
        this.tourAssignmentNotifications = true;
        this.visitAssignmentNotifications = true;
        this.timezone = null;
        this.referralMapExperience = true;
        this.persistReferralSearch = false;
        this.referralSearchCommunities = "onlyReferred";
        this.smsNotifications = true;
        this.useProvisionedPhoneOnIntakePdf = false;
        this.promptSendAnotherEmail = true;
        this.makeCallsFrom = "browser";
    }
    static load(doc) {
        const result = new UserPreferences();
        if (!doc) {
            doc = {};
        }
        Maybe.fromValue(doc.displayBestContactPhoneOnDashboard).withValue(v => (result.displayBestContactPhoneOnDashboard = v));
        if (doc.useBulkCommunityEmail === false) {
            result.useBulkCommunityEmail = false;
        }
        Maybe.fromValue(doc.showAdditionalContactsForReferrals).withValue(v => (result.showAdditionalContactsForReferrals = v));
        Maybe.fromValue(doc.showContactPhoneNumbersForReferrals).withValue(v => (result.showContactPhoneNumbersForReferrals = v));
        Maybe.fromValue(doc.showContactEmailAddrsForReferrals).withValue(v => (result.showContactEmailAddrsForReferrals = v));
        Maybe.fromValue(doc.showContactLocationsForReferrals).withValue(v => (result.showContactLocationsForReferrals = v));
        Maybe.fromValue(doc.showCareProvidersForReferrals).withValue(v => (result.showCareProvidersForReferrals = v));
        Maybe.fromValue(doc.showHealthInsuranceForReferrals).withValue(v => (result.showHealthInsuranceForReferrals = v));
        Maybe.fromValue(doc.showClientBudget).withValue(v => (result.showClientBudget = v));
        Maybe.fromValue(doc.showClientLocation).withValue(v => (result.showClientLocation = v));
        Maybe.fromValue(doc.showReferralCityOnMainTable).withValue(v => (result.showReferralCityOnMainTable = v));
        Maybe.fromValue(doc.showReferralLastUpdatedDateOnMainTable).withValue(v => (result.showReferralLastUpdatedDateOnMainTable = v));
        Maybe.fromValue(doc.preferAge).withValue(v => (result.preferAge = v));
        Maybe.fromValue(doc.activeTaskSortOrder).withValue(v => (result.activeTaskSortOrder = v));
        Maybe.fromValue(doc.completedTaskSortOrder).withValue(v => (result.completedTaskSortOrder = v));
        Maybe.fromValue(doc.clientUpdateNotifications).withValue(v => (result.clientUpdateNotifications = v));
        Maybe.fromValue(doc.clientUpdateReferralOwnerNotifications).withValue(v => (result.clientUpdateReferralOwnerNotifications = v));
        Maybe.fromValue(doc.reminderEnabled).withValue(v => (result.reminderEnabled = v));
        Maybe.fromValue(doc.reminderEnabledDate).withValue(v => (result.reminderEnabledDate = v));
        Maybe.fromValue(doc.defaultCommunityCompareTemplateId).withValue(v => (result.defaultCommunityCompareTemplateId = v === "_" ? null : v));
        Maybe.fromValue(doc.defaultShowCoverPage).withValue(v => (result.defaultShowCoverPage = v));
        Maybe.fromValue(doc.liveLinkURLText).withValue(v => (result.liveLinkURLText = v));
        Maybe.fromValue(doc.attachCommunityPDFByDefault).withValue(v => (result.attachCommunityPDFByDefault = v));
        Maybe.fromValue(doc.useLiveLinkByDefault).withValue(v => (result.useLiveLinkByDefault = v));
        Maybe.fromValue(doc.defaultCommunitySortOrder).withValue(v => (result.defaultCommunitySortOrder =
            typeof v === "string" &&
                SettingsCommunitySortTypes.includes(v)
                ? v
                : defaultDefaultCommunitySortOrder));
        result.workflowSettings = doc.workflowSettings ?? {};
        Object.keys(doc).forEach(key => {
            if (key.startsWith("$workflow")) {
                result.workflowSettings[key] = doc[key];
            }
        });
        Maybe.fromValue(doc.bccMyself).withValue(v => (result.bccMyself = v));
        Maybe.fromValue(doc.preferredClientAssignmentFilter).withValue(v => (result.preferredClientAssignmentFilter = v));
        Maybe.fromValue(doc.taskAssignmentNotifications).withValue(v => (result.taskAssignmentNotifications = v));
        Maybe.fromValue(doc.tourAssignmentNotifications).withValue(v => (result.tourAssignmentNotifications = v));
        Maybe.fromValue(doc.visitAssignmentNotifications).withValue(v => (result.visitAssignmentNotifications = v));
        Maybe.fromValue(doc.timezone).withValue(v => (result.timezone = v));
        Maybe.fromValue(doc.taskDuration).withValue(v => (result.taskDuration = v));
        Maybe.fromValue(doc.referralMapExperience).withValue(v => (result.referralMapExperience = v));
        Maybe.fromValue(doc.persistReferralSearch).withValue(v => (result.persistReferralSearch = v));
        Maybe.fromValue(doc.referralSearchCommunities).withValue(v => (result.referralSearchCommunities = v));
        Maybe.fromValue(doc.smsNotifications).withValue(v => (result.smsNotifications = v));
        Maybe.fromValue(doc.useProvisionedPhoneOnIntakePdf).withValue(v => (result.useProvisionedPhoneOnIntakePdf = v));
        Maybe.fromValue(doc.promptSendAnotherEmail).withValue(v => (result.promptSendAnotherEmail = v));
        result.makeCallsFrom = makeCallsFromOf(doc.makeCallsFrom);
        return result;
    }
    static clone(doc) {
        const result = new UserPreferences();
        if (doc) {
            result.displayBestContactPhoneOnDashboard =
                doc.displayBestContactPhoneOnDashboard;
            result.useBulkCommunityEmail = doc.useBulkCommunityEmail;
            result.preferAge = doc.preferAge;
            result.showAdditionalContactsForReferrals =
                doc.showAdditionalContactsForReferrals;
            result.showContactPhoneNumbersForReferrals =
                doc.showContactPhoneNumbersForReferrals;
            result.showContactEmailAddrsForReferrals =
                doc.showContactEmailAddrsForReferrals;
            result.showContactLocationsForReferrals =
                doc.showContactLocationsForReferrals;
            result.showReferralCityOnMainTable = doc.showReferralCityOnMainTable;
            result.showReferralLastUpdatedDateOnMainTable =
                doc.showReferralLastUpdatedDateOnMainTable;
            result.activeTaskSortOrder = doc.activeTaskSortOrder;
            result.completedTaskSortOrder = doc.completedTaskSortOrder;
            result.clientUpdateNotifications = doc.clientUpdateNotifications;
            result.clientUpdateReferralOwnerNotifications =
                doc.clientUpdateReferralOwnerNotifications;
            result.reminderEnabled = doc.reminderEnabled;
            result.reminderEnabledDate = doc.reminderEnabledDate;
            result.defaultCommunityCompareTemplateId =
                doc.defaultCommunityCompareTemplateId;
            result.defaultShowCoverPage = doc.defaultShowCoverPage;
            result.liveLinkURLText = doc.liveLinkURLText;
            result.attachCommunityPDFByDefault = doc.attachCommunityPDFByDefault;
            result.useLiveLinkByDefault = doc.useLiveLinkByDefault;
            result.defaultCommunitySortOrder = doc.defaultCommunitySortOrder;
            result.workflowSettings = { ...doc.workflowSettings };
            result.bccMyself = doc.bccMyself;
            result.preferredClientAssignmentFilter = doc.preferredClientAssignmentFilter;
            result.taskAssignmentNotifications = doc.taskAssignmentNotifications;
            result.tourAssignmentNotifications = doc.tourAssignmentNotifications;
            result.visitAssignmentNotifications = doc.visitAssignmentNotifications;
            result.timezone = doc.timezone;
            result.smsNotifications = doc.smsNotifications;
            result.useProvisionedPhoneOnIntakePdf = doc.useProvisionedPhoneOnIntakePdf;
            result.promptSendAnotherEmail = doc.promptSendAnotherEmail;
            result.makeCallsFrom = doc.makeCallsFrom;
        }
        return result;
    }
}
//# sourceMappingURL=user-preferences.js.map